// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"139":"81c78863","197":"7c34b016","204":"79bd2003","229":"729be333","284":"e9fd1044","300":"34833a86","383":"bb6b890c","479":"f0cb5127","673":"14df425a","723":"3c07366e","741":"f7557e3d","770":"1f163e80","781":"4349aa9d","878":"8b36b206","953":"b0bebd16"}[chunkId] + ".chunk.js";
};